import React, { useState, useEffect, useRef } from 'react';
import { useStore } from '../context/store';

export default function Pagination() {
    const {
        state,
        dispatch
    } = useStore();

    /**
	 * Get an array of the pages (made up of numbers and ellipses)
	 * 
	 * @param  {number} currentPage
	 * @param  {number} totalPages  
	 * @return {array}              Array of "page" objects { text, value } used to build out options for paginating.
	 */
	const getRange = ( currentPage, totalPages ) => {
		var delta = 2,
			left = currentPage - delta,
			right = currentPage + delta + 1,
			range = [],
			rangeWithDots = [],
			lastNum;

		// Build out number range array.
		for ( let i = 1; i <= totalPages; i++ ) {
			if ( i == 1 || i == totalPages || i >= left && i < right ) {
				range.push( i );
			}
		}

		for ( let i of range ) {

			// If this isn't the first run of the loop
			if ( lastNum ) {
				/**
				 * If 2 is the exact distance between the the prev and current number, just push the number
				 * If its > 2, add an elipses
				 */
				if ( 2 === i - lastNum ) {
					rangeWithDots.push({
						text: lastNum + 1,
						value: lastNum + 1,
					});
				} else if ( 1 !== i - lastNum ) {
					let value = lastNum < currentPage ? i - delta : lastNum + delta;

					rangeWithDots.push({
						text: '...',
						value: value
					});
				}
			}

			// Push the current number.
			rangeWithDots.push({
				text: i,
				value: i
			});

			lastNum = i;
		}

		return rangeWithDots;
	}

	const changePage = value => {
		dispatch({ type: 'setCurrentPage', payload: value })
		document.querySelector('.ygl-filters').scrollIntoView({
			behavior: 'smooth'
		});
	}

	if ( 'undefined' !== typeof state && state.totalPages > 1 ) {
		const range         = getRange( state.currentPage, state.totalPages );
		const leftDisabled  = 1 >= state.currentPage;
		const rightDisabled = state.totalPages === state.currentPage;

		const pre = 'ygl-pagination';

		return (
			<div className={ pre }>
				<div className="container">
					<div className={`${pre}__holder`}>
					<button
						className={`${pre}__arrow-prev`}
						disabled={leftDisabled}
						onClick={() => dispatch({ type: 'setCurrentPage', payload: state.currentPage - 1 })}
					></button>

					<nav role="navigation" aria-label="Rental pagination">
						<ul className={`${pre}__list`}>
							{range.map(({ text, value }, index) => {
								const current      = value === +state.currentPage
								const currentClass = current ? `${pre}__item--active` : ''
								return (
									<li
										className={`${pre}__item ${currentClass}`}
										onClick={() => changePage( value )}
										role="link"
										aria-current={current}
										key={index}
									>
										{text}
									</li>
								)
							})}
						</ul>
					</nav>

					<button
						className={`${pre}__arrow-next`}
						disabled={rightDisabled}
						onClick={() => dispatch({ type: 'setCurrentPage', payload: state.currentPage + 1 })}
					></button>
					</div>
				</div>
			</div>
		)
	}

	return '';
}